export default __webpack_public_path__ + "static/steamTunnel-a3dd0ed1b4ea10e49f7e35b7e80e72b3.svg";